async function getSessionData(userId) {
  const supabase = useSupabaseClient();
  let { data, error } = await supabase.from('auth.sessions').select('*').eq('user_id', userId);

  if (error) {
    console.error(error);
    return;
  }

  return data;
}

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const user = useSupabaseUser();
  const sessionData = await getSessionData(user.value.id);
  const path = '/';
  console.log('`one-session-per-user` Middleware');
  console.log(sessionData);
});
